export default function nextTick(cb: (...params: Array<any>) => any) {
    setTimeout(() => {
        cb();
    }, 0);
}
